import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      patientPortal: {
         boundServices: {
            addBound: 'Powiąż usługę',
            addNewBound: 'Dodaj nowe powiązanie',
            bound: 'Powiąż',
            boundService: 'Powiąż usługę',
            boundServiceCreated: 'Powiązanie usług zostało dodane.',
            boundServiceRemoveConfirmation: 'Czy na pewno chcesz usunąć powiązanie poniższych usług?',
            boundServiceRemoved: 'Powiązanie usług zostało usunięte.',

            choosePatientPortalService: 'Wybierz usługę w drEryk Pacjent',
            chooseReceptionService: 'Wybierz usługę recepcyjną',
            currencySuffix: 'zł',
            leave: 'Wyjdź',
            leavingFormConfirmation: 'Czy chcesz wyjść z formularza? <suffix />',

            noBoundedServices: 'Brak powiązanych usług',
            patientPortalService: 'Usługa w drEryk Pacjent',
            patientPortalServiceWithName: 'Usługa w drEryk Pacjent: <patientPortalServiceName />',
            placeholder: 'Powiąż usługi, by pacjenci mogli się na nie rejestrować przez drEryk Pacjent.',
            price: 'Cena',
            receptionService: 'Usługa recepcyjna',
            receptionServiceWithName: 'Usługa recepcyjna: <receptionServiceName />',
            remove: 'Usuń',
            removingBoundService: 'Usuwasz powiązanie usług',
            servicesAvailableInPatientPortal: 'Usługi dostępne w drEryk Pacjent',
            unsavedDataWillBeLost: 'Utracisz niezapisane dane.',
         },
         dataFetchingFault: 'Nie udało się załadować danych. Spróbuj ponownie później.',
         dataForPatients: 'Dane dla pacjentów',
         healthcareProviderCode: 'Kod placówki',
         patientPortalLinkWithCode: 'Link do rejestracji z kodem',
         preInterviewSettings: {
            channelMap: {
               EMAIL: 'E-mail',
               SMS: 'SMS',
               SMS_AND_EMAIL: 'SMS i e-mail',
            },
            enable: 'Pre-wywiad w drEryk Pacjent',
            enableDescription:
               'Umożliwia pacjentom wypełnianie ankiety z pre-wywiadem po zalogowaniu do drEryk Pacjent.',
            header: 'Ustawienia pre-wywiadu',
            notificationChannel: 'Jak informować pacjentów o pre-wywiadzie dostępnym do uzupełnienia?',
            sendingMode: 'W którym momencie ma zostać wysłany pre-wywiad?',
            sendingModeMap: {
               MANUAL: 'Wysyłaj ręcznie do wybranych pacjentów',
               ON_APPOINTMENT_CREATED: 'Wysyłaj automatycznie po umówieniu wizyty',
            },
         },
         settings: {
            allowAppointmentRequests:
               'Pozwalaj na przesłanie prośby o wyznaczenie terminu, gdy specjalista nie ma dostępnych terminów w portalu drEryk Pacjent',
            allowCustomAppointmentRequests:
               'Pozwalaj na przesłanie prośby o wyznaczenie innego terminu wizyty, niż terminy dostępne w portalu drEryk Pacjent',
            appointmentRequestsEmail: 'E-mail do obsługi zgłoszeń',
            appointmentRequestsSettings: 'Ustawienia rejestrowania wizyt',
            blockShortAdvanceBooking:
               'Zablokuj możliwość rejestracji przez portal drEryk Pacjent, jeśli do terminu wizyty pozostało zbyt mało czasu',
            changesSaved: 'Zmiany zostały zapisane.',
            minimumLeadingPeriodInHours: 'Minimalne wyprzedzenie (w godz.)',
            save: 'Zapisz',
         },
         widget: {
            copyCode: 'Kopiuj kod',
            helpCenterManual: 'Instrukcja instalacji',
            scriptInfo: 'Kod widgeta do wklejenia na stronę placówki',
         },
      },
   },
};

export const patientPortalTranslationKeys = createScopedTranslationKeys(translations.pl, 'patientPortal');
export const boundServiceTranslationKeys = patientPortalTranslationKeys.boundServices;
export const preInterviewSettingsTranslationKeys = patientPortalTranslationKeys.preInterviewSettings;
export const settingsTranslationKeys = patientPortalTranslationKeys.settings;
